import * as model from "../models";
import { AdditionalChargeActions, AdditionalChargesToSave, BoxOfficeActions } from "../actions"

export interface AdditionalChargeState {
	additionalCharges: model.AdditionalCharge[];
	collectionUrl: string;
};

const initialState: AdditionalChargeState  = {
	additionalCharges: [],
	collectionUrl: null
}

export const additionalChargeReducer = (state = initialState, action) => {
	switch (action.type) {

		case AdditionalChargeActions.LOAD_ADDITIONALCHARGE_COLLECTION_SUCCESS:
			return {
				additionalCharges: action.payload,
				collectionUrl: state.collectionUrl
			}

		case AdditionalChargeActions.LOAD_ADDITIONALCHARGE_COLLECTION:
			return {
				additionalCharges: [],
				collectionUrl: action.payload
			}

		case BoxOfficeActions.CLEAR_EVENTSERVER_STATE:
			return initialState;

		default: {
			return state;
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/reducers/additional-charge.reducer.ts